export default "__VITE_ASSET__ByuOHurL__"